import React from 'react';
import { Box, NotificationType, Notification } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

interface ISelectMerchantsNotification {
  benefitType: string;
}

export const SelectMerchantsNotification = ({
  benefitType
}: ISelectMerchantsNotification) => {
  const { t } = useTranslation();
  const { fontSemiBold } = useTheme();

  return (
    <Notification
      type={NotificationType.Info}
      text={
        <Box>
          {t(
            'components.manage_benefits_select_merchants.notification.part_one'
          )}
          <Box display="inline-block" fontWeight={fontSemiBold} px={0.5}>
            {t(
              `components.manage_benefits_select_merchants.notification.${benefitType}.benefit`
            )}
          </Box>
          {t(
            'components.manage_benefits_select_merchants.notification.part_two'
          )}
          <Box display="inline-block" fontWeight={fontSemiBold} px={0.5}>
            {t(
              'components.manage_benefits_select_merchants.notification.employee_benefits'
            )}
          </Box>
          {t(
            'components.manage_benefits_select_merchants.notification.part_three'
          )}
        </Box>
      }
    />
  );
};
